import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { RestApiService } from '@/services'

import { ApplicationState } from '@/state/root.models'
import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'

import { WalletState } from '../models'
import { WALLET } from './api.routes'

const restApiService = new RestApiService()

//const restApiService: RestApiService = Container.get(RestApiService)

export const getBonusBalanceThunk = createAsyncThunk(
  ActionTypes.GET_BONUS_BALANCE,
  async (payload: { playerId: string }, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState() as ApplicationState

      restApiService.requestParams = {
        method: 'GET',
        endpoint: WALLET.GET_BONUS_BALANCE,
        queries: jsonToQueryString(payload),
      }

      const response: { balance: number } = await restApiService.getData(
        auth.brand.siteId.toString(),
        auth.token,
      )

      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  },
)

export const getBonusBalanceExtraReducer = (
  builder: ActionReducerMapBuilder<WalletState>,
) => {
  builder.addCase(getBonusBalanceThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getBonusBalanceThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false

    const roundedBalance =
      typeof payload.balance === 'number'
        ? Number(payload.balance.toFixed(2))
        : undefined

    state.currentWallet = {
      ...state.currentWallet,
      bonusBalance: roundedBalance,
    }
  })
}
